import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiHelper } from 'src/cad/common/services/api/api-helper';

@Injectable()
export class CapacityReleaseOfferBidsRatesApi {
  private readonly endpoint: string = 'capacity-release/offer/';
  private readonly suffix: string = '/bids';
  private readonly suffix2: string = '/rates';

  constructor(private apiHelper: ApiHelper) {}

  public getById = (auctionId: number | string, bidId: number | string): Observable<any> => {
    return this.apiHelper.request(this.endpoint + auctionId + this.suffix + '/' + bidId + this.suffix2);
  }

  public save = (auctionId: number | string, bidId: number | string, rateDataList: any): Observable<any> => {
    return this.apiHelper.request(
      this.endpoint + auctionId + this.suffix + '/' + bidId + this.suffix2 + '/save',
      { body: rateDataList }
    );
  }

  public getRatesDetail = (auctionId: number | string, bidId: number | string): Observable<any> => {
    return this.apiHelper.request(this.endpoint + auctionId + this.suffix + '/' + bidId + this.suffix2 + '/detail');
  }

  public getPathRateDetail = (auctionId: number | string, bidId: number | string, pathId: number | string): Observable<any> => {
    return this.apiHelper.request(this.endpoint + auctionId + this.suffix + '/' + bidId + this.suffix2 + '/path-rate-detail/' + pathId);
  }
}
